import * as Actions from './user-configuration.actions';
import { UserConfigurationStateInterface } from './user-configuration.model';

const initialState: UserConfigurationStateInterface = {
  userConfigurationDataLoading: false,
  userConfigurationDataLoaded: false,
  siteConfigurationDataLoading: false,
  siteConfigurationDataLoaded: false,
  userConfigurationData: {},
  siteConfigurationData: {},
  temporaryMode: false,
};

export function userConfigurationReducer(
  state: UserConfigurationStateInterface = initialState,
  action: Actions.UserConfigurationActions,
): UserConfigurationStateInterface {
  switch (action.type) {
    case Actions.GET_USER_CONFIGURATION_DATA_LOADING:
      return {
        ...state,
        userConfigurationDataLoading: true,
        userConfigurationDataLoaded: false,
        siteConfigurationDataLoading: true,
        siteConfigurationDataLoaded: false,
      };
    case Actions.UPDATE_USER_CONFIGURATION_LOADING:
      return {
        ...state,
        userConfigurationDataLoading: true,
        userConfigurationDataLoaded: false,
      };
    case Actions.GET_USER_CONFIGURATION_DATA_LOADED:
      return {
        ...state,
        userConfigurationDataLoading: false,
        userConfigurationDataLoaded: true,
        siteConfigurationDataLoading: false,
        siteConfigurationDataLoaded: true,
        userConfigurationData: action.userConfiguration ? action.userConfiguration : {},
        siteConfigurationData: action.siteConfiguration ? action.siteConfiguration : {},
      };
    case Actions.UPDATE_USER_CONFIGURATION_LOADED:
      return {
        ...state,
        userConfigurationDataLoading: false,
        userConfigurationDataLoaded: true,
        userConfigurationData: action.payload ? action.payload : {},
      };

    case Actions.USER_CONFIGURATION_FETCH_ERROR:
      return {
        ...state,
        userConfigurationDataLoading: false,
        userConfigurationDataLoaded: true,
      };

    case Actions.UPDATE_TEMPORARY_MODE:
      return {
        ...state,
        temporaryMode: action.temporaryMode,
      };
    case Actions.UPDATE_SITE_CONFIGURATION_LOADING:
      return {
        ...state,
        siteConfigurationDataLoading: true,
        siteConfigurationDataLoaded: false,
      };
    case Actions.UPDATE_SITE_CONFIGURATION_LOADED:
      return {
        ...state,
        siteConfigurationDataLoading: false,
        siteConfigurationDataLoaded: true,
        siteConfigurationData: action.payload ? action.payload : {},
      };
    case Actions.DELETE_USER_COMPONENT_CONFIGURATION_LOADED:
      return {
        ...state,
        userConfigurationDataLoading: false,
        userConfigurationDataLoaded: true,
        userConfigurationData: action.payload ? action.payload : {},
      };
    default:
      return state;
  }
}
